import type { Task } from '../types';
import { filterByViewer, type ViewerFilterContext, type ViewerValue } from './viewerFilter';

/**
 * Bins open (non-completed, non-deleted) tasks by `teamId` after applying the
 * current viewer filter. Used by the sidebar so its per-group badges match
 * what the user will actually see when they click into the group with their
 * active viewer selection (Just me / a person / a user-team / Everyone).
 */
export function countOpenTasksByTeam(
  tasks: Task[],
  viewer: ViewerValue,
  ctx: ViewerFilterContext
): Record<string, number> {
  const open = tasks.filter((t) => t.status !== 'completed' && !t.deletedAt);
  const filtered = filterByViewer(open, viewer, ctx);
  const counts: Record<string, number> = {};
  for (const t of filtered) {
    counts[t.teamId] = (counts[t.teamId] ?? 0) + 1;
  }
  return counts;
}
